export default "__VITE_ASSET__C_Bx0dqj__"